import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';

class StorageLocationDetailsValidityCtrl implements ng.IController {
    public isEditMode: boolean;
    public isCreateMode: boolean;
    public storageLocation: StorageLocationDto;
    public isEditable = this.isCreateMode || this.isEditMode;
    public validityExpanded: boolean = true;
    public loggedInUser: LoginResult;
    private minDate: any;

    constructor() {}

    $onInit() {
        if (this.isEditable) {
            let newStartDate = new Date();
            this.minDate = moment(newStartDate).add(1, 'hour').toDate();
            this.storageLocation.validity.start = this.minDate;
        }
    }

    public isInfiniteValidity(validity: string | Date) {
        return moment(validity).isSameOrBefore(moment('9999-12-31 23:59'));
    }
}

angular.module('app').component('pkpStorageLocationDetailsValidity', {
    controller: StorageLocationDetailsValidityCtrl,
    template:
        require('app/storage-location/storage-location-details-validity.component.html'),
    bindings: {
        form: '=',
        loggedInUser: '<',
        storageLocation: '=',
        isEditMode: '<',
        isCreateMode: '<'
    }
});
